import {useContext} from "react";
import {ModalDetails} from "@Components/modal/modal-context";

export const useIsInMobileModal = (): boolean => {
    const modalDetails = useContext(ModalDetails);
    return !!modalDetails?.isMobileModal;
}